import { ButtonAdd, DataGrid, DeleteButton, Header, Pagination, TableNew } from "@/components/DataGrid";
import { Outlet, useNavigate, useParams } from "react-router-dom"
import { Resource } from "./model";
import { useFetchList, useRemove } from "./service";
import { headers, idKey } from "./settings";
import { Drawer, DrawerContent, useDisclosure } from "@chakra-ui/react";

export const ListPermissoes = () => {
    const { id } = useParams();
    const { mutateAsync: handleRemove } = useRemove();
    const { isOpen, onClose } = useDisclosure({ defaultIsOpen: true });
    const nav = useNavigate();

    const useQuery = (params: any) => {
        return useFetchList(params, id || '')
    }

    return (
        <>
            <Drawer placement="bottom" isOpen={isOpen} onClose={() => { onClose(); setTimeout(() => nav('..'), 200) }}>
                <DrawerContent>
                    <DataGrid style={{ borderTop: '2px solid #ccc', padding: 0, maxH: '600px', overflow: 'auto' }} query={useQuery}>
                        <Header style={{ borderRadius: 'none' }}>

                            <DeleteButton onConfirm={handleRemove} />

                            <ButtonAdd />
                        </Header>

                        <TableNew<Resource> editable={true} idKey={idKey} headers={headers} />

                        <Pagination style={{ borderRadius: 0 }} />
                    </DataGrid>

                    <Outlet />
                </DrawerContent>
            </Drawer>
        </>
    )
}